//import React, { Component } from 'react';
import React from 'react';
import {Link} from 'react-router-dom';
import Logo_Text from '../../images/logo_text.png';
import Menu from '../../navigation/menu';
import Menubottom from '../../navigation/menubottom';
import Image from '../../images/ESSP32ROSE01_1920x1080.jpg';
import { Player } from 'video-react';
import '../../../node_modules/video-react/dist/video-react.css';
import Video from '../../videos/ESSP32ROSE01.mp4';
import ESSP32ROSE01PayPal from '../../paypal/ESSP32ROSE01PayPal.js';
//import AccordionInfo from './accordionInfo';

function ESSP32ROSE01() {


  return (

    <main className="container">
    <div className="logo">
    <br/><br/>
    <Link to="/">
    <img src={Logo_Text} alt="Yari Nanichi-logo" />
    </Link>
    <p><strong>Art To Wear Jewelry</strong></p>
    <br/>
    </div>

    <div className="buttons-bar">
    <Menu/>
    </div>

             <div className="video">

                 <Player
                      fluid
                      preload='none'
                      LoadingSpinner
                      poster={Image}
                      src={Video}
                    />

             </div>

             <div align="center" className="token_interface">
             <br/>
             <p align="justify">Handmade sterling silver earrings, embellished with
             Rose and Aurore Boreale crystals from Swarovski®.  Hammered texture and polished like a mirror.
             Extremely comfortable to wear with a sterling silver post and clutch disc system.
             Made in USA with imported Swarovski® crystals from Austria. Play the video
             in full screen to appreciate the beauty and craftsmanship.
             </p>
             <p>
             <strong>Price $140.00 (30% off from $200.00)</strong>
             </p>
             <p>
             <strong>Free USPS Priority Mail Shipping</strong>
             </p>
             <ESSP32ROSE01PayPal/>
             </div>


            <div className="buttons-bar">
                <Menubottom/>
                </div>

                </main>
              );
            }

            export default ESSP32ROSE01;
